import './SourceTreeBlock.css';

/**
 * Renders a parsed source-tree diagram as boxed rows — connector + filename left,
 * wrapped description right, so long comments no longer stretch the tree horizontally.
 * @param {object} props
 * @param {Array} props.rows - rows from sourceTreeParser.parseTreeBlock
 */
export default function SourceTreeBlock({ rows }) {
    return (
        <div className="stb-block">
            {rows.map((row, i) => {
                if (row.kind === 'folder') {
                    return <div className="stb-folder" key={i}>{row.raw}</div>;
                }
                if (row.kind === 'item') {
                    return (
                        <div className="stb-row" key={i}>
                            <div className="stb-file">
                                <span className="stb-connector">{row.connector}</span>
                                <span className="stb-filename">{row.filename}</span>
                            </div>
                            <div className={`stb-desc ${row.desc ? '' : 'stb-desc-empty'}`}>{row.desc}</div>
                        </div>
                    );
                }
                return <div className="stb-raw" key={i}>{row.raw}</div>;
            })}
        </div>
    );
}
